import asBentoPage from 'common/bento/hoc/asBentoPage';

import { OnboardingPage } from '../../../Onboarding/legacy/types';
import Header from '../../components/EpAgreementWallHeader';
import { GetEpAgreementWallContextQuery } from '../../graphql/queries/getEpAgreementWallContext.gql';
import PersonalStatusPageContent from './components/PersonalStatusPageContent';
import usePersonalStatusHandlers from './hooks/usePersonalStatusHandlers';

interface PersonalStatusProps {
  moduleData: GetEpAgreementWallContextQuery;
  onNext: () => void;
  onPrev: () => void;
}

const PersonalStatus = asBentoPage<PersonalStatusProps>(
  ({ Layout, moduleData, onNext, onPrev }) => {
    const personalStatusProps = usePersonalStatusHandlers({
      destinationPageOnRejection: '' as OnboardingPage,
      destinationPageOnSuccess: '' as OnboardingPage,
      setCurrentPage: onNext,
      user: moduleData.viewer.profile,
    });

    return (
      <Layout header={<Header onPrev={onPrev} />}>
        <PersonalStatusPageContent {...personalStatusProps} />
      </Layout>
    );
  },
);

export default PersonalStatus;
